import { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import { INK } from "./styles";

const CLOSE_AFTER_MS = 1500;

export default function DialogSuccess({ titleId, title, detail, onClose }: { titleId: string; title: string; detail: string; onClose: () => void }) {
  const closeRef = useRef(onClose);
  closeRef.current = onClose;
  useEffect(() => {
    const timer = setTimeout(() => closeRef.current(), CLOSE_AFTER_MS);
    return () => clearTimeout(timer);
  }, []);
  return (
    <Box onClick={onClose} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', py: 3, cursor: 'pointer' }}>
      <Box sx={{ width: 64, height: 64, borderRadius: '50%', bgcolor: '#ecfdf3', color: '#039855', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CheckCircleOutline sx={{ fontSize: 36 }} />
      </Box>
      <Typography id={titleId} component="h2" sx={{ fontSize: 18, fontWeight: 600 }}>{title}</Typography>
      <Typography sx={{ fontSize: 13, color: INK.muted }}>{detail}</Typography>
    </Box>
  );
}
